import React, { useState } from "react"
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { Row, Col, BreadcrumbItem, Dropdown, DropdownToggle, DropdownItem, DropdownMenu } from "reactstrap"

const Breadcrumb = props => {

  return (
    <Col sm={12}>
      <div className="page-title-box d-flex align-items-center justify-content-between">
        <h4 className="font-size-24 mb-0">{props.breadcrumbHeaderItem ? props.breadcrumbHeaderItem : props.breadcrumbItem}</h4>
        <ol className="breadcrumb mb-0">
          {
            (props.maintitle) ?
              <>
                <BreadcrumbItem>
                  <Link to="/dashboard">{props.maintitle}</Link>
                </BreadcrumbItem>
              </> : ''
          }
          {props.title &&
            <BreadcrumbItem>
              <Link to="/#">{props.title}</Link>
            </BreadcrumbItem>
          }
          <BreadcrumbItem active>
            {props.breadcrumbItem}
          </BreadcrumbItem>
        </ol>
      </div>
      <div style={{width: '100%', height: 1, backgroundColor: '#dadada', marginBottom: 24}}></div>
    </Col>
  )
}

Breadcrumb.propTypes = {
  breadcrumbItem: PropTypes.string,
  title: PropTypes.string
}

export default Breadcrumb
